import React, { useEffect } from "react"
import withStyles from "react-jss"
import "./Ticker.css"
import { useCountUp } from "react-countup"
import { tickerarrow } from "../../assets/images"
import smoothscroll from "smoothscroll-polyfill"

smoothscroll.polyfill()

const styles = {
  container: {
    position: "relative",
    width: "100%",
    maxWidth: "1140px",
    margin: "0 auto",
    padding: 0,
    color: "#ffffff",
    boxSizing: "border-box",
  },
  arrow: {
    position: "absolute",
    top: "85vh",
    left: "50%",
    transform: "translateX(-50%)",
  },
  countContainer: {
    boxSizing: "border-box",
    position: "sticky",
    top: 0,
    width: "100%",
    height: "50vh",
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "center",
    margin: 0,
    padding: 0,
  },
  triggerContainer: {
    position: "relative",
    transition: "opacity 0.3s ease-in",
    "& > :first-child": {
      opacity: "0",
      pointerEvents: "none",
    },
    "& > :nth-last-child(2)": {
      opacity: "0",
      pointerEvents: "none",
      margin: "50vh auto",
    },
    "& > :last-child": {
      opacity: "0",
      pointerEvents: "none",
      margin: "50vh auto -80vh auto",
    },
  },
  textCommon: {
    position: "sticky",
    top: "calc(40vh + 128px)",
    margin: "50vh auto",
    boxSizing: "border-box",
    padding: "8px 24px",
    background: "#ffffff",
    color: "#000000",
    textAlign: "center",
  },
  text: {
    composes: "$textCommon",
    fontFamily: "WiredMono",
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "14px",
    lineHeight: "16px",
    borderRadius: "0px",
    width: "fit-content",
    "@media only screen and (max-width: 840px)": {
      padding: "8px 24px",
    },
  },
  discriptiontext: {
    composes: "$textCommon",
    fontFamily: "BreveText",
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "19px",
    lineHeight: "1.5em",
    borderRadius: "4px",
    width: "100%",
    maxWidth: "500px",
    "@media only screen and (max-width: 840px)": {
      padding: "8px 8px",
      width: "80%",
      //top: "calc(50vh + 128px)",
    },
  },
}

const TickerExperiment = ({ classes, hideTicker }) => {
  const counterValues = [9409, 19103, 23111, 24190, 26989, 29110]
  const { update } = useCountUp({
    ref: "ticker-counter-1",
    start: counterValues[0],
    end: counterValues[0],
    duration: 0.5,
    separator: ",",
    onUpdate: () => {
      const counter = document.querySelector(
        "#contentScoreTicker .rightBoxTicker .rightBoxTickerContent .rightBoxTickerContentPara span"
      )
      counter.setAttribute("aria-busy", "true")
    },
    onEnd: () => {
      const counter = document.querySelector(
        "#contentScoreTicker .rightBoxTicker .rightBoxTickerContent .rightBoxTickerContentPara span"
      )
      counter.setAttribute("aria-busy", "false")
    },
  })

  useEffect(() => {
    const items = Array.from(
      document.querySelectorAll("#textContentOfTicker p")
    ).slice(0, 7)
    const counter = document.querySelector(
      "#contentScoreTicker .rightBoxTicker .rightBoxTickerContent .rightBoxTickerContentPara span"
    )
    const detectIntersection = (entries) => {
      for (let e of entries) {
        let j = items.indexOf(e.target)
        // scroll down
        if (e.isIntersecting) {
          const ind = j,
            condition = 0 <= ind && ind < counterValues.length
          if (condition) {
            if (e.target.classList.contains("redTick")) {
              counter.classList.add("redColor")
            } else {
              counter.classList.remove("redColor")
            }
            const value = condition ? counterValues[j] : counterValues.at(-1)
            update(value)
          }
        }
        // scroll up
        else {
          if (e.boundingClientRect.top < 1000) {
            const ind = j - 1
            if (ind >= 0) {
              const intersectingElem = items[ind]
              if (intersectingElem.classList.contains("redTick")) {
                counter.classList.add("redColor")
              } else {
                counter.classList.remove("redColor")
              }
              const value = ind >= 0 ? counterValues[ind] : counterValues.at(0)
              update(value)
            }
          }
        }
      }
    }

    const options = {
      threshold: 0.25,
    }
    const observer = new IntersectionObserver(detectIntersection, options)
    items.forEach((i) => observer.observe(i))
    return () => {
      items.forEach((i) => {
        observer.disconnect(i)
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      <section className={classes.container} aria-label="Introduction">
        <figure className={classes.countContainer}>
          <section id="contentScoreTicker">
            <div className="rightBoxTicker">
              <div className="rightBoxTickerContent tickerBox">
                <div className="rating">RISK RANKING</div>
                <div className="rightBoxTickerContentPara visibleTicker">
                  <span id="ticker-counter-1" aria-live="polite" />
                </div>
                <div className={classes.arrow} aria-hidden="true">
                  <img src={tickerarrow} alt="Indicator to scroll down."></img>
                </div>
              </div>
            </div>
          </section>
        </figure>
        <article
          className={classes.triggerContainer}
          id="textContentOfTicker"
          style={{
            opacity: hideTicker ? 0 : 1,
          }}>
          <p className={classes.text} aria-hidden="true" />
          <p className={classes.text}>BEING YOUNG</p>
          <p className={classes.text}>BEING FEMALE</p>
          <p className={classes.text}>HAVING CHILDREN</p>
          <p className={`${classes.text} redTick`}>NOT KNOWING DUTCH</p>
          <p className={`${classes.text} redTick`}>STRUGGLING TO PAY BILLS</p>
          {/* <p className={`${classes.discriptiontext} redTick`}>
            An algorithm used by the welfare agency in Rotterdam, the
            Netherlands, uses these criteria to assess how much aid people need
            ...
            <br />
            Instead, the algorithm is telling investigators if they should be
            investigated for fraud.
          </p> */}
          <p className={`${classes.text} redTick`} aria-hidden="true" />
          <p className={`${classes.text} redTick`} aria-hidden="true" />
        </article>
      </section>
    </>
  )
}

export default withStyles(styles)(TickerExperiment)
